import {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  FaMapMarkerAlt,
  FaClock,
  FaDollarSign,
  FaHeart,
  FaRegHeart,
  FaCalendarAlt,
  FaBriefcaseMedical,
} from "react-icons/fa";

import { Link } from "react-router-dom";

import assignments from "../data/assignments";


function formatDate(dateValue) {
  if (!dateValue) {
    return "";
  }

  return new Date(
    `${dateValue}T12:00:00`
  ).toLocaleDateString(
    "en-CA",
    {
      month: "short",
      day: "numeric",
      year: "numeric",
    }
  );
}


function getPayDisplay(assignment) {
  if (
    assignment.payDisplay
  ) {
    return assignment.payDisplay;
  }

  if (
    assignment.pay !== null &&
    assignment.pay !== undefined
  ) {
    return `$${assignment.pay}/hour`;
  }

  return "Rate available upon offer";
}


function AssignmentBoardPro() {
  const [
    search,
    setSearch,
  ] = useState("");

  const [
    profession,
    setProfession,
  ] = useState("All");

  const [
    province,
    setProvince,
  ] = useState("All");

  const [
    shift,
    setShift,
  ] = useState("All");

  const [
    savedAssignments,
    setSavedAssignments,
  ] = useState([]);


  useEffect(() => {
    const saved =
      JSON.parse(
        localStorage.getItem(
          "zethSavedAssignments"
        ) || "[]"
      );

    setSavedAssignments(
      saved
    );
  }, []);


  function toggleSaveAssignment(
    id
  ) {
    const updatedSavedAssignments =
      savedAssignments.includes(
        id
      )
        ? savedAssignments.filter(
            (
              assignmentId
            ) =>
              assignmentId !==
              id
          )
        : [
            ...savedAssignments,
            id,
          ];

    setSavedAssignments(
      updatedSavedAssignments
    );

    localStorage.setItem(
      "zethSavedAssignments",
      JSON.stringify(
        updatedSavedAssignments
      )
    );

    window.dispatchEvent(
      new Event(
        "zeth-saved-jobs-updated"
      )
    );
  }


  const filteredAssignments =
    useMemo(() => {
      return assignments.filter(
        (assignment) => {
          const searchableText = `
            ${assignment.title || ""}
            ${assignment.profession || ""}
            ${assignment.facility || ""}
            ${assignment.city || ""}
            ${assignment.province || ""}
            ${assignment.unit || ""}
          `.toLowerCase();

          const matchesSearch =
            searchableText.includes(
              search.toLowerCase()
            );

          const matchesProfession =
            profession === "All" ||
            assignment.profession ===
              profession;

          const matchesProvince =
            province === "All" ||
            assignment.province ===
              province;

          const matchesShift =
            shift === "All" ||
            assignment.shift ===
              shift;

          return (
            matchesSearch &&
            matchesProfession &&
            matchesProvince &&
            matchesShift
          );
        }
      );
    }, [
      search,
      profession,
      province,
      shift,
    ]);


  return (
    <section
      className="assignment-pro-section"
      id="assignments"
    >
      <div className="assignment-pro-container">
        <div className="assignment-pro-heading">
          <p className="section-label">
            LIVE TRAVEL ASSIGNMENTS
          </p>

          <h2>
            Find your next
            healthcare opportunity
          </h2>

          <p>
            Search current travel
            assignments by profession,
            province, location and
            shift.
          </p>
        </div>


        <div className="assignment-filters">
          <input
            type="search"
            placeholder="Search assignments..."
            value={search}
            onChange={(
              event
            ) =>
              setSearch(
                event.target.value
              )
            }
          />


          <select
            value={profession}
            onChange={(
              event
            ) =>
              setProfession(
                event.target.value
              )
            }
          >
            <option value="All">
              All professions
            </option>

            <option value="RN">
              Registered Nurse
            </option>

            <option value="RPN">
              Registered Practical
              Nurse
            </option>

            <option value="PSW">
              Personal Support
              Worker
            </option>
          </select>


          <select
            value={province}
            onChange={(
              event
            ) =>
              setProvince(
                event.target.value
              )
            }
          >
            <option value="All">
              All provinces
            </option>

            <option value="Ontario">
              Ontario
            </option>

            <option value="Nova Scotia">
              Nova Scotia
            </option>
          </select>


          <select
            value={shift}
            onChange={(
              event
            ) =>
              setShift(
                event.target.value
              )
            }
          >
            <option value="All">
              All shifts
            </option>

            <option value="Various">
              Various
            </option>

            <option value="Day">
              Day
            </option>

            <option value="Evening">
              Evening
            </option>

            <option value="Night">
              Night
            </option>
          </select>
        </div>


        <div className="assignment-results-header">
          <strong>
            {
              filteredAssignments.length
            }{" "}
            assignment
            {filteredAssignments.length ===
            1
              ? ""
              : "s"}{" "}
            found
          </strong>
        </div>


        <div className="assignment-pro-grid">
          {filteredAssignments.map(
            (assignment) => (
              <article
                className="assignment-pro-card"
                key={
                  assignment.id
                }
              >
                <div className="assignment-card-top">
                  <span
                    className={`assignment-status ${assignment.status.toLowerCase()}`}
                  >
                    {
                      assignment.status
                    }
                  </span>

                  <span className="assignment-profession">
                    {
                      assignment.profession
                    }
                  </span>

                  <button
                    className="assignment-save-button"
                    type="button"
                    onClick={() =>
                      toggleSaveAssignment(
                        assignment.id
                      )
                    }
                    aria-label={
                      savedAssignments.includes(
                        assignment.id
                      )
                        ? "Remove saved assignment"
                        : "Save assignment"
                    }
                  >
                    {savedAssignments.includes(
                      assignment.id
                    ) ? (
                      <FaHeart />
                    ) : (
                      <FaRegHeart />
                    )}
                  </button>
                </div>


                <h3>
                  {assignment.title}
                </h3>


                <p className="assignment-facility">
                  {
                    assignment.facility
                  }
                </p>


                <div className="assignment-details">
                  <span>
                    <FaMapMarkerAlt />

                    {
                      assignment.city
                    }
                    ,{" "}
                    {
                      assignment.province
                    }
                  </span>


                  {assignment.unit && (
                    <span>
                      <FaBriefcaseMedical />

                      {
                        assignment.unit
                      }
                    </span>
                  )}


                  <span>
                    <FaClock />

                    {
                      assignment.shift
                    }{" "}
                    shift
                  </span>


                  <span>
                    <FaDollarSign />

                    {getPayDisplay(
                      assignment
                    )}
                  </span>


                  {assignment.startDate &&
                    assignment.endDate && (
                      <span>
                        <FaCalendarAlt />

                        {formatDate(
                          assignment.startDate
                        )}{" "}
                        –{" "}
                        {formatDate(
                          assignment.endDate
                        )}
                      </span>
                    )}
                </div>


                <div className="assignment-card-actions">
                  <Link
                    className="secondary-button"
                    to={`/assignments/${assignment.id}`}
                  >
                    View Details
                  </Link>

                  <Link
                    className="primary-button"
                    to="/professional/login"
                  >
                    Apply Now
                  </Link>
                </div>
              </article>
            )
          )}
        </div>


        {filteredAssignments.length ===
          0 && (
          <div className="assignment-empty">
            <h3>
              No assignments found
            </h3>

            <p>
              Try changing your search
              or filter selections.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}


export default AssignmentBoardPro;